import {
  registerApplication,
  start,
  addErrorHandler,
  getAppStatus,
  LOAD_ERROR,
} from 'single-spa';
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from 'single-spa-layout';
import { authUtils } from './utils/authEvents';
import { keycloakSessionLifecycle } from './auth/keycloakSessionLifecycle';
import handleBreadcrumbs from './utils/breadcrumb-handler';

const copilotRootConfig = () => {
  const routes = constructRoutes(document.querySelector('#single-spa-layout'));
  const applications = constructApplications({
    routes,
    loadApp({ name }) {
      return System.import(name);
    },
  });
  const layoutEngine = constructLayoutEngine({ routes, applications });

  applications.forEach(registerApplication);
  layoutEngine.activate();
  addErrorHandler(err => {
    if (getAppStatus(err.appOrParcelName) === LOAD_ERROR) {
      System.delete(System.resolve(err.appOrParcelName));
    }
  });

  keycloakSessionLifecycle();
  window.authUtils = authUtils;

  handleBreadcrumbs();
  start();
};

export default copilotRootConfig;
